import * as React from "react";
import { forwardRef } from "react";
const SvgKeys = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M64.545 17.171c-7.893-8.144-20.895-8.35-29.04-.456s-8.35 20.896-.457 29.04a20.54 20.54 0 0 0 23.114 4.437l1.633 1.685 3.057.048L60.5 55.71l1.693 1.747 6.878.108-.848 5.338 1.504 1.552 5.738-.292-1.213 4.185 1.035 1.068 5.267-.778 2.257 2.329-1.188 2.657 14.132.604.836-4.573L68.26 40.42a20.54 20.54 0 0 0-3.715-23.249M48.63 20.552a6.756 6.756 0 1 1-9.703 9.403 6.756 6.756 0 0 1 9.703-9.403" />
    <path d="M40.545 6.563a21.62 21.62 0 0 0-30.57-.48 21.62 21.62 0 0 0-.48 30.569 21.6 21.6 0 0 0 9.305 5.644 24 24 0 0 1-.07-3.445 18.4 18.4 0 0 1-6.906-4.456 18.375 18.375 0 0 1 .408-25.983 18.375 18.375 0 0 1 25.984.408 18.375 18.375 0 0 1 3.536 20.372 4.44 4.44 0 0 0 3.382.277 21.62 21.62 0 0 0-4.59-22.906" />
    <path d="M57.154 53.731c-8.546 2.813-18.027.796-24.391-5.754l-.004-.004c-5.474-5.648-7.56-13.357-6.313-20.584a20.54 20.54 0 0 0-3.779 17.822 20.54 20.54 0 0 0 17.892 15.29l.586 2.275 2.633 1.554-3.918 2.124.607 2.356 5.923 3.497-3.377 4.219.539 2.094 5.131 2.584-3.124 3.037.372 1.44 4.96 1.93.81 3.141-2.347 1.72 11.982 7.518 2.989-3.561-10.156-39.423a20.5 20.5 0 0 0 3.352-2.896z" />
  </svg>
);
const ForwardRef = forwardRef(SvgKeys);
export default ForwardRef;
